<template>
  <div v-if="userdata">
    <b-row class="match-height">
      <b-col
        cols="12"
        md="6"
      >
        <b-card>
          <b-card-body class="p-0">
            <table class="mt-2 mt-xl-0 w-100  table table-striped table-borderless table-sm">
              <tbody> <tr
                v-for="(info, index) in informations"
                :key="index"
              >
                <th class="w-25">
                  <!-- <feather-icon
                    :icon="`${info.icon}Icon`"
                    class="mr-75 d-none d-sm-block"
                  /> -->
                  <span class="font-weight-bold line-height-1">{{ info.title }}</span>
                </th>
                <td>
                  <span
                    class="line-height-1 small"
                    :class="{'badge badge-light-warning badge-pill': info.highlight}"
                  >{{ info.value }}</span>
                </td>
              </tr>
              </tbody>
            </table>

            <hr>
            <attachments-viewer
              v-model="userdata.attachments"
              :refaid="refaid"
            />
          </b-card-body></b-card>
      </b-col>

      <b-col
        cols="12"
        md="6"
      >
        <b-card>
          <b-card-body class="p-0">
            <b-form-group
              :label="$t('contributors.filter-tags-label')"
              label-for="tags"
            >
              <div class="d-flex align-items-center justify-content-end">
                <tags-selector
                  v-model="userdata.tags"
                  :taggable="true"
                  :tags-options="tagsOptions"
                  :tags-colors="tagsColors"
                  :disabled="!isUserAllowWrite"
                />
              </div>
            </b-form-group>
            <b-form-group
              :label="$t('common.notes')"
              label-for="notes"
            >
              <div class="form-label-group ">
                <quill-editor
                  id="notes"
                  v-model="userdata.infos.notes"
                  class="quill"
                  :disabled="!isUserAllowWrite"
                  :options="quillEditorOptions"
                />
              </div>
            </b-form-group>
          </b-card-body></b-card>
      </b-col>
    </b-row>
  </div>

</template>

<script>
/* eslint-disable import/no-extraneous-dependencies */
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
/* eslint-disable no-nested-ternary */
import {
  BRow, BCol, BFormGroup, BCardBody, BCard,
} from 'bootstrap-vue'
import { quillEditor } from 'vue-quill-editor'
import i18n from '@/libs/i18n'
import authService from '@/vue.auth.service'
import {
  avatarText, resolveAvatarVariant, resolveStatusVariant, formatDate, formatAddress, formatDateHumanFriendly, quillEditorOptions,
} from '../layouts/layouts.utils'
import TagsSelector from '../layouts/tables/TagsSelector.vue'
import AttachmentsViewer from '../attachments/AttachmentsViewer.vue'

export default {
  components: {
    BRow, BCol, BFormGroup, BCardBody, BCard, TagsSelector, AttachmentsViewer, quillEditor,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    // eslint-disable-next-line vue/require-prop-types
    refaid: {
      required: true,
    },
    tagsOptions: {
      type: Array,
      default: null,
    },
    tagsColors: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      isUserAllowWrite: authService.isUserInRole('write'),
    }
  },
  computed: {
    userdata: {
      get() { return this.value },
      set(value) { this.$emit('input', value) },
    },
    informations() {
      const infos = []
      if (this.userdata) {
        const data = this.userdata.infos
        infos.push({ icon: '', title: i18n.t('contributors.code'), value: data.contributorCode })
        infos.push({ icon: '', title: i18n.t('contributors.contributor-type'), value: data.contributorType })
        infos.push({ icon: 'Calendar', title: i18n.t('contributors.birth-date'), value: (data.birthDate ? formatDate(data.birthDate, 'DD MMM yyyy') : null) })
        infos.push({ icon: 'Check', title: i18n.t('contributors.gender'), value: (data.gender === 'F' ? i18n.t('common.gender-F') : (data.gender === 'M' ? i18n.t('common.gender-M') : null)) })
        infos.push({ icon: 'CreditCard', title: i18n.t('contributors.fiscal-code'), value: data.fiscalCode })
        if (data.address) {
          infos.push({ icon: 'MapPin', title: i18n.t('contributors.address'), value: data.address.addressLine })
          infos.push({ icon: 'Flag', title: i18n.t('contributors.address-city'), value: formatAddress(data.address) })
        }
        infos.push({ icon: 'Mail', title: i18n.t('contributors.email'), value: data.email })
        infos.push({ icon: 'Phone', title: i18n.t('contributors.contact'), value: data.contact })
        infos.push({
          icon: 'Box', title: i18n.t('contributors.sorgente'), value: data.sorgente, highlight: (data.sorgente !== null),
        })
        infos.push({ icon: 'LogIn', title: i18n.t('contributors.annoAdesione'), value: data.annoAdesione })
        infos.push({ icon: 'LogOut', title: i18n.t('contributors.annoCancellazione'), value: data.annoCancellazione })

        infos.push({ icon: 'Edit3', title: i18n.t('common.last-update'), value: `${formatDateHumanFriendly(this.userdata.lastUpdate)} - ${this.userdata.editor}` })
      }
      return infos.filter(i => i.value)
    },
  },
  setup() {
    return {
      avatarText,
      resolveAvatarVariant,
      resolveStatusVariant,
      quillEditorOptions,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
